import noAuthApiRequest from 'Utils/noAuthApiRequest'
import GetSchoolUrl from 'Utils/GetSchoolUrl'
import globalsService from 'Services/globalsService'
// eslint-disable-next-line import/no-cycle
import sentryService from 'Services/sentryService'
import mixpanelService from 'Services/mixpanelService'

export default {
  signup(d, redirectUrl) {
    const u = d.user
    mixpanelService.signup(u)
    this.login(d, redirectUrl)
  },
  saveLoginData(d) {
    const u = d.user
    globalsService.setCookie('authToken', d.authToken)
    globalsService.setCookie('loggedUser', u)
  },
  login(d, redirectUrl) {
    const u = d.user
    this.saveLoginData(d)
    sentryService.login(u)
    mixpanelService.login(u)
    if (redirectUrl) {
      window.location.href = redirectUrl
    } else {
      window.location.href = '/dashboard'
    }
  },
  logout(reload = true) {
    if (globalsService.getCookie('authToken')) {
      noAuthApiRequest
        .post('/logout/', { authToken: globalsService.getCookie('authToken') })
        .then(
          () => {},
          () => {}
        )
    }
    globalsService.removeCookie('authToken')
    globalsService.removeCookie('loggedUser')
    sentryService.logout()
    mixpanelService.logout()
    if (reload && typeof window !== 'undefined') {
      window.location.href = '/'
    }
  },
  mobileNumberAuthStart(data) {
    return noAuthApiRequest.post('/auth/start/mobilenumber/', data)
  },
  signup2(user) {
    return noAuthApiRequest.post('/auth/signup/', user)
  },
  authenticate2(data) {
    return noAuthApiRequest.post('/auth/login/', data)
  },
  verifyCode(data) {
    return noAuthApiRequest.post('/login/code/verify/', data)
  },
  goToSchool: (s, authToken) => {
    // auth token passed explicitly from institute signup
    window.location.href = GetSchoolUrl(s, `/auth/login/${authToken}/`, true)
  },
  resendOTP(data) {
    return noAuthApiRequest.post('/auth/resend/otp/', data)
  },
}
